module.exports = __webpack_public_path__ + "987032ea5d57c93d8da215678eae3b86.woff2";